import { NgModule } from '@angular/core';
import { FaIconLibrary, FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { config } from '@fortawesome/fontawesome-svg-core';
import {
  faAddressBook,
  faAngleDown,
  faAngleLeft,
  faAngleRight,
  faAngleUp,
  faArrowAltCircleRight,
  faArrowRight,
  faArrowsAlt,
  faBalanceScale,
  faBan,
  faBars,
  faBell,
  faBriefcase,
  faCalendarDay,
  faCheck,
  faCheckCircle,
  faChevronDown,
  faChevronUp,
  faCog,
  faCogs,
  faCoins,
  faEnvelope,
  faExclamationTriangle,
  faEye,
  faEyeSlash,
  faFastForward,
  faFax,
  faGear,
  faGlobeAmericas,
  faHeart,
  faHome,
  faInbox,
  faInfoCircle,
  faList,
  faListAlt,
  faMapMarkerAlt,
  faMinus,
  faPause,
  faPencilAlt,
  faPhone,
  faPlayCircle,
  faPlus,
  faPrint,
  faQuestionCircle,
  faRepeat,
  faRightFromBracket,
  faSearch,
  faShareAlt,
  faShoppingCart,
  faSpinner,
  faStar,
  faStarHalf,
  faTh,
  faTimes,
  faTimesCircle,
  faTrashAlt,
  faTriangleExclamation,
  faUndo,
  faUser,
  faUserCheck,
} from '@fortawesome/free-solid-svg-icons';

@NgModule({
  imports: [FontAwesomeModule],
  exports: [FontAwesomeModule],
})
export class IconModule {
  constructor(library: FaIconLibrary) {
    config.autoAddCss = false;
    library.addIcons(
      faAddressBook,
      faAngleDown,
      faAngleLeft,
      faAngleRight,
      faAngleUp,
      faArrowAltCircleRight,
      faArrowRight,
      faArrowsAlt,
      faBalanceScale,
      faBan,
      faBars,
      faBriefcase,
      faCalendarDay,
      faCheck,
      faCheckCircle,
      faChevronDown,
      faChevronUp,
      faCog,
      faCogs,
      faEnvelope,
      faFastForward,
      faFax,
      faGear,
      faGlobeAmericas,
      faHeart,
      faHome,
      faExclamationTriangle,
      faEye,
      faEyeSlash,
      faInbox,
      faInfoCircle,
      faList,
      faListAlt,
      faMapMarkerAlt,
      faMinus,
      faPause,
      faPencilAlt,
      faPhone,
      faPlayCircle,
      faPlus,
      faPrint,
      faQuestionCircle,
      faRepeat,
      faRightFromBracket,
      faSearch,
      faShareAlt,
      faShoppingCart,
      faSpinner,
      faStar,
      faStarHalf,
      faTh,
      faTimes,
      faTimesCircle,
      faTrashAlt,
      faTriangleExclamation,
      faUndo,
      faUser,
      faUserCheck,
      faBell,
      faCoins
    );
  }
}
